import { cloneCourseDocument, type CourseDocument } from './CourseDocument';

export const COURSE_EDITOR_DRAFT_KEY = 'golf-sim.course-editor.draft';
export const COURSE_EDITOR_RECOVERY_KEY = 'golf-sim.course-editor.recovery';

export interface DraftSnapshot {
  document: CourseDocument;
  savedAt: string;
}

export class CourseEditorDraftRepository {
  constructor(
    private readonly draftKey = COURSE_EDITOR_DRAFT_KEY,
    private readonly recoveryKey = COURSE_EDITOR_RECOVERY_KEY,
  ) {}

  saveDraft(document: CourseDocument, now = new Date()): DraftSnapshot {
    const previous = localStorage.getItem(this.draftKey);
    if (previous) localStorage.setItem(this.recoveryKey, previous);
    const snapshot = { document: cloneCourseDocument(document), savedAt: now.toISOString() };
    localStorage.setItem(this.draftKey, JSON.stringify(snapshot));
    return snapshot;
  }

  loadDraft(): DraftSnapshot | null {
    return this.read(this.draftKey);
  }

  loadRecovery(): DraftSnapshot | null {
    return this.read(this.recoveryKey);
  }

  private read(key: string): DraftSnapshot | null {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw) as DraftSnapshot;
      return parsed.document ? parsed : null;
    } catch {
      return null;
    }
  }
}
